export default "__VITE_ASSET__692fd615__"